import React from 'react'
import { Alerts, ButtonAction, IconTitle, InputArea, InputButton, Loading } from '../../Simple'
import { AddCredCard, AddCupom, ModalAddCpf, SelecionaHoraFixa } from '../../Modais'
import { Grid, Typography, Box, Tooltip, Divider, CardContent, Tabs, Tab } from '@mui/material'
import { AiOutlineQuestionCircle } from 'react-icons/ai'
import { BiFileFind, BiMoneyWithdraw } from 'react-icons/bi'
import { IoChevronBackOutline } from 'react-icons/io5'
import { CheckoutContext } from '../../../contexts/CheckoutContext'
import { EmpresasContext } from '../../../contexts/EmpresasContext'
import { IoIosBasketball } from 'react-icons/io'
import { iconsPayment } from '../../../assets'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'
import ResumoAgendamento from './ResumoAgendamento'
import { ToastMessages } from '../../ToastMessages'
import { Services } from '../../../services'
import moment from 'moment'

export default function DesktopCheckout() {
  const { sttPg, actionsCtxEmps } = React.useContext(EmpresasContext)
  const { sttCtxChkt, modaisChkt, actionsChkt, loadCh, pagamentosDisponiveis } =
    React.useContext(CheckoutContext)
  const { sttCtxAgend } = React.useContext(AgendamentoContext)
  const reagendamento = sttCtxAgend.reagendamento
  const [observations, setObservations] = React.useState(
    Object.keys(reagendamento).length > 0 ? reagendamento.observacoes : '',
  )
  const [selectedTab, setSelectedTab] = React.useState(1)

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue)
  }

  const avoidPaymentChange = text => {
    ToastMessages.paymentMethodCannotBeChanged(text)
  }

  const pagamentoLocal =
    Object.keys(reagendamento).length > 0
      ? reagendamento.formaPagamento === 'MAQUINA_CARTAO' ||
        reagendamento.formaPagamento === 'LOCAL' ||
        reagendamento.formaPagamento === 'DINHEIRO'
      : false

  const recebimentoPix = sttCtxChkt.diaria?.metodosPagamento.find(metodo => metodo === 'PIX')
    ? true
    : sttCtxChkt.horaFixaSelecionada === null
      ? sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.recebimentos_pix_avulso
      : sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.recebimentos_pix_fixo

  const recebimentoCartao = sttCtxChkt.diaria?.metodosPagamento.find(
    metodo => metodo === 'Cartão de Crédito',
  )
    ? true
    : sttCtxChkt.horaFixaSelecionada === null
      ? sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.recebimentos_cartao_avulso
      : sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.recebimentos_cartao_fixo

  const recebimentoDinheiro =
    sttCtxChkt.horaFixaSelecionada === null
      ? sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.recebimentos_dinheiro_avulso
      : sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.recebimentos_dinheiro_fixo

  const recebimentoMaq = sttCtxChkt.diaria?.metodosPagamento.find(
    metodo => metodo === 'Pagamento Local',
  )
    ? true
    : sttCtxChkt.horaFixaSelecionada === null
      ? sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.recebimentos_maquina_local_avulso
      : sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.recebimentos_maquina_local_fixo

  const [values, setValues] = React.useState({
    porcentagemSinal: sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.porcentagemSinal,
    valorSinal: sttCtxChkt.diaria
      ? sttCtxChkt.diaria.valorTotal
      : (sttCtxChkt.agendamentoConfirme?.valorTotal *
          sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.porcentagemSinal) /
        100,
    valorSubtotal: !sttCtxChkt.diaria
      ? sttCtxChkt.agendamentoConfirme?.valorTotal
      : sttCtxChkt.diaria.valorTotal,
  })

  React.useEffect(() => {
    if (sttCtxChkt.cupomAplicado !== null) {
      setValues({
        porcentagemSinal: sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.porcentagemSinal,
        valorSubtotal:
          sttCtxChkt.agendamentoConfirme?.valorTotal - sttCtxChkt.cupomAplicado.valorDesconto,
        valorSinal:
          ((sttCtxChkt.agendamentoConfirme?.valorTotal - sttCtxChkt.cupomAplicado.valorDesconto) *
            sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.porcentagemSinal) /
          100,
      })
    } else {
      setValues({
        porcentagemSinal: sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.porcentagemSinal,
        valorSubtotal: sttCtxChkt.agendamentoConfirme?.valorTotal,
        valorSinal:
          (sttCtxChkt.agendamentoConfirme?.valorTotal *
            sttCtxChkt.agendamentoConfirme?.quadra.regraAgendamento.porcentagemSinal) /
          100,
      })
    }
  }, [sttCtxChkt.cupomAplicado])

  async function StartAgendamento() {
    if (sttCtxChkt.horaFixaSelecionada !== null) {
      await actionsChkt.ConfirmeAgendamentoFixo(observations)
    } else {
      await actionsChkt.ConfirmeAgendamentoAvulso(observations)
    }
  }

  async function StartReagendamento() {
    await actionsChkt.ReagendarPedido(reagendamento.idpedido, observations)
  }

  async function StartAgendamentoDiaria() {
    await actionsChkt.AgendarDiaria()
  }

  function Showregras() {
    return Alerts.swal(
      'warning',
      'Regras de Cancelamento',
      Services.RetornaRegraCancelamentoSwal(sttPg.empresa.regrasCancelamento[0]),
    )
  }

  function VerificaBttConfirmar() {
    if (sttCtxChkt.diaria) {
      if (sttCtxChkt.selPix || sttCtxChkt.selCardCredit || sttCtxChkt.selDinheiro) {
        return false
      } else {
        return true
      }
    } else if (
      sttCtxChkt.esporteSelected !== null &&
      Object.keys(reagendamento).length > 0 &&
      !pagamentoLocal &&
      reagendamento.valorTotal === sttCtxChkt.agendamentoConfirme.valorTotal
    )
      return false
    else if (sttCtxChkt.selTotal || sttCtxChkt.selSinal) {
      if (
        sttCtxChkt.selCardCredit ||
        sttCtxChkt.selPix ||
        sttCtxChkt.selMaqCredit ||
        sttCtxChkt.selDinheiro
      ) {
        if (sttCtxChkt.esporteSelected === null) {
          return true
        }
        if (sttPg.empresa.solicitaCPF) {
          if (sttCtxChkt.cpfObrigatorio === null) {
            return false
          } else {
            return false
          }
        } else {
          return false
        }
      } else {
        return true
      }
    } else {
      return true
    }
  }

  function StartActionConfirme() {
    if (sttCtxChkt.diaria) {
      if (sttCtxChkt.selPix || sttCtxChkt.selCardCredit || sttCtxChkt.selDinheiro) {
        StartAgendamentoDiaria()
      } else {
        Alerts.swal(
          'warning',
          'Selecione uma forma de pagamento',
          'Selecione uma forma de pagamento para prosseguir',
        )
      }
    } else if (sttCtxChkt.selTotal || sttCtxChkt.selSinal) {
      if (
        sttCtxChkt.selCardCredit ||
        sttCtxChkt.selPix ||
        sttCtxChkt.selMaqCredit ||
        sttCtxChkt.selDinheiro
      ) {
        if (sttPg.empresa.solicitaCPF) {
          if (sttCtxChkt.cpfObrigatorio === null) {
            actionsChkt.handleModaisChkt('cpf', true)
          } else {
            if (sttCtxChkt.esporteSelected !== null) {
              Object.keys(reagendamento).length === 0 ? StartAgendamento() : StartReagendamento()
            }
          }
        } else {
          if (sttCtxChkt.esporteSelected !== null) {
            Object.keys(reagendamento).length === 0 ? StartAgendamento() : StartReagendamento()
          } else {
            return
          }
        }
      } else if (
        Object.keys(reagendamento).length > 0 &&
        !pagamentoLocal &&
        reagendamento.valorTotal === sttCtxChkt.agendamentoConfirme.valorTotal
      )
        StartReagendamento()
      else {
        Alerts.swal(
          'warning',
          'Selecione uma forma de pagamento',
          'Selecione uma forma de pagamento para prosseguir',
        )
      }
    } else {
      Alerts.swal(
        'warning',
        'Selecione uma forma de pagamento',
        'Selecione uma forma de pagamento para prosseguir',
      )
    }
  }

  function ReturnLabelBttConfirmar() {
    if (sttCtxChkt.diaria) {
      if (sttCtxChkt.selPix || sttCtxChkt.selCardCredit || sttCtxChkt.selDinheiro) {
        return 'Confirmar Diária'
      } else {
        return 'Selecione uma forma de pagamento'
      }
    } else if (sttCtxChkt.selTotal || sttCtxChkt.selSinal) {
      if (
        sttCtxChkt.selCardCredit ||
        sttCtxChkt.selPix ||
        sttCtxChkt.selMaqCredit ||
        sttCtxChkt.selDinheiro
      ) {
        if (sttCtxChkt.esporteSelected === null) {
          return 'Selecione um esporte'
        } else if (sttPg.empresa.solicitaCPF) {
          if (sttCtxChkt.cpfObrigatorio === null) {
            return 'Adicione o seu CPF para prosseguir'
          } else {
            return `Confirmar ${Object.keys(reagendamento).length === 0 ? 'Agendamento' : 'Reagendamento'}`
          }
        } else {
          return `Confirmar ${Object.keys(reagendamento).length === 0 ? 'Agendamento' : 'Reagendamento'}`
        }
      } else if (
        Object.keys(reagendamento).length > 0 &&
        !pagamentoLocal &&
        reagendamento.valorTotal === sttCtxChkt.agendamentoConfirme.valorTotal
      )
        return 'Confirmar Reagendamento'
      else {
        return 'Selecione uma forma de pagamento'
      }
    } else {
      return 'Selecione uma forma de pagamento'
    }
  }

  return (
    <>
      {loadCh.confirmar || loadCh.confirmarDiaria ? (
        <Box
          className='contain-page-checkout tw-justify-center'
          sx={{ width: 'calc(100% - 30px)', height: '100%', maxHeight: '500px' }}
        >
          <Loading
            styleText={{ fontSize: '18px', textAlign: 'center' }}
            text={
              !sttCtxChkt.diaria
                ? `Não feche esta tela. \nAguarde, por favor. Seus horários estão sendo marcados...`
                : `Não feche esta tela. \nAguarde, por favor. Sua diária está sendo marcada...`
            }
          />
        </Box>
      ) : (
        <Box className='contain-page-checkout' sx={{ width: 'calc(100% - 30px)', height: 'auto' }}>
          {modaisChkt.horaFx && (
            <SelecionaHoraFixa
              show={modaisChkt.horaFx}
              ClosedModal={() => {
                actionsChkt.handleModaisChkt('horaFx', false)
              }}
            />
          )}
          {modaisChkt.cupom && (
            <AddCupom
              show={modaisChkt.cupom}
              onClose={() => {
                actionsChkt.handleModaisChkt('cupom', false)
              }}
            />
          )}
          {modaisChkt.cartaoCredito && (
            <AddCredCard
              modal={modaisChkt.cartaoCredito}
              onClick={() => {}}
              mode={'select-card'}
              ClosedModal={() => {
                actionsChkt.handleModaisChkt('cartaoCredito', false)
              }}
            />
          )}
          {modaisChkt.cpf && (
            <ModalAddCpf
              modal={modaisChkt.cpf}
              ClosedModal={() => {
                actionsChkt.handleModaisChkt('cpf', false)
              }}
            />
          )}

          <IoChevronBackOutline
            className='icon-back-page'
            onClick={() => actionsCtxEmps.handleSttPg('modePg', 'quadras')}
          />
          <Typography variant='h5' className='text-title-page'>
            Finalize{' '}
            {Object.keys(reagendamento).length === 0
              ? sttCtxChkt.diaria
                ? 'sua Diária'
                : 'seu Agendamento'
              : 'seu Reagendamento'}
          </Typography>
          <Box className='contain-row-checkout' display='flex' justifyContent='center'>
            {!sttCtxChkt.diaria && (
              <>
                <GridContainer>
                  <Grid item width={'100%'}>
                    <IconTitle Icon={BiFileFind} title='Detalhes do Agendamento' />
                  </Grid>
                  <Grid item width={'100%'} sx={{ padding: '0px 30px 0px 15px' }}>
                    <Typography variant='h6' className='text-subtitle-low'>
                      Alguma observação?
                    </Typography>
                    <InputArea
                      rows={4}
                      fullWidth
                      value={observations}
                      label='Alguma observação?'
                      onChange={e => setObservations(e.target.value)}
                      placeholder='Ex: Preciso de colete, raquete, etc...'
                    />
                    {Object.keys(reagendamento).length === 0 && (
                      <ButtonAction
                        title={'Configurar um horário fixo'}
                        titleLabel={
                          sttCtxChkt.horaFixaSelecionada === null
                            ? 'É um horário fixo?'
                            : 'Horário fixo'
                        }
                        text={
                          sttCtxChkt.horaFixaSelecionada
                            ? `${sttCtxChkt.horaFixaSelecionada.tipoMensalista}, começa em ${moment(
                                sttCtxChkt.horaFixaSelecionada.dataInicio,
                              ).format('DD/MM/YY')}`
                            : ''
                        }
                        confirmed={sttCtxChkt.horaFixaSelecionada ? true : false}
                        onClick={() => {
                          actionsChkt.handleModaisChkt('horaFx', true)
                        }}
                      />
                    )}
                    {sttPg.empresa.solicitaCPF && (
                      <ButtonAction
                        title={'CPF obrigatório'}
                        titleLabel={!sttCtxChkt.cpfObrigatorio ? 'CPF obrigatório' : ''}
                        text={!sttCtxChkt.cpfObrigatorio ? '' : 'CPF: ' + sttCtxChkt.cpfObrigatorio}
                        confirmed={sttCtxChkt.cpfObrigatorio ? true : false}
                        onClick={() => {
                          actionsChkt.handleModaisChkt('cpf', true)
                        }}
                      />
                    )}
                  </Grid>
                  <Grid item width={'100%'} sx={{ marginTop: '15px' }}>
                    <IconTitle Icon={IoIosBasketball} title='Esporte' />
                  </Grid>
                  <Grid item width={'100%'} sx={{ padding: '0px 30px 0px 15px' }}>
                    <CardContent sx={stMob.containListEsports}>
                      {sttPg.selectedQuadra.categoriasEsporte.map((categoria, index) => (
                        <React.Fragment key={index}>
                          <ButtonAction
                            title={null}
                            titleLabel={categoria.descricao}
                            text={''}
                            Icon={`${categoria.urlFoto}${categoria.foto}`}
                            pay='payMetod'
                            onClick={() => {
                              if (
                                sttCtxChkt.esporteSelected?.idcategoriaEsporte ===
                                categoria.idcategoriaEsporte
                              ) {
                                actionsChkt.handleSttCtxChkt('esporteSelected', null)
                              } else {
                                actionsChkt.handleSttCtxChkt('esporteSelected', categoria)
                              }
                            }}
                            confirmed={
                              sttCtxChkt.esporteSelected?.idcategoriaEsporte ===
                              categoria.idcategoriaEsporte
                            }
                          />
                        </React.Fragment>
                      ))}
                    </CardContent>
                  </Grid>
                </GridContainer>
                <Divider orientation='vertical' flexItem />
              </>
            )}

            <GridContainer>
              <Grid item width={'100%'}>
                <IconTitle Icon={BiMoneyWithdraw} title='Forma de Pagamento' />
              </Grid>
              {Object.keys(reagendamento).length > 0 &&
              !pagamentoLocal &&
              reagendamento.valorTotal === sttCtxChkt.agendamentoConfirme.valorTotal ? (
                <Typography>
                  {reagendamento.valorTotal !== reagendamento.valorAPagar &&
                  reagendamento.valorRealizado !== 0 &&
                  reagendamento.valorAPagar !== 0 ? (
                    <span>
                      Este reagendamento não terá custos adicionais neste momento, pois o sinal no
                      valor de{' '}
                      <strong>
                        R$ {reagendamento.valorRealizado.toFixed(2).toString().replace('.', ',')}
                      </strong>{' '}
                      já foi previamente pago no agendamento original.
                    </span>
                  ) : reagendamento.valorTotal === sttCtxChkt.agendamentoConfirme.valorTotal ? (
                    <span>
                      Este reagendamento não terá custos adicionais, pois o valor de{' '}
                      <strong>
                        R$ {reagendamento.valorRealizado.toFixed(2).toString().replace('.', ',')}
                      </strong>{' '}
                      já foi previamente pago no agendamento original.
                    </span>
                  ) : (
                    <span>
                      Este reagendamento não terá custos adicionais, pois o valor de{' '}
                      <strong>
                        R$ {reagendamento.valorRealizado.toFixed(2).toString().replace('.', ',')}
                      </strong>{' '}
                      já foi previamente pago no agendamento original.
                    </span>
                  )}
                </Typography>
              ) : (
                !sttCtxChkt.diaria &&
                sttCtxChkt.horaFixaSelecionada === null && (
                  <Grid item width={'100%'} sx={{ padding: '0px 30px 0px 15px' }}>
                    {Object.keys(reagendamento).length > 0 && !pagamentoLocal ? (
                      reagendamento.valorTotal < sttCtxChkt.agendamentoConfirme.valorTotal && (
                        <Typography>
                          O valor do horário reagendado é de{' '}
                          <strong>
                            R${' '}
                            {sttCtxChkt.agendamentoConfirme.valorTotal
                              .toFixed(2)
                              .toString()
                              .replace('.', ',')}
                          </strong>
                          . Como já foi pago{' '}
                          <strong>
                            R$ {reagendamento.valorTotal.toFixed(2).toString().replace('.', ',')}
                          </strong>
                          , restam{' '}
                          <strong>
                            R${' '}
                            {(sttCtxChkt.agendamentoConfirme.valorTotal - reagendamento.valorTotal)
                              .toFixed(2)
                              .toString()
                              .replace('.', ',')}
                          </strong>{' '}
                          a ser pago.
                        </Typography>
                      )
                    ) : (
                      <>
                        <Typography variant='h6' className='text-subtitle-low'>
                          Como você deseja pagar?
                        </Typography>
                        {(sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.tipoPagamento ===
                          'AMBOS' ||
                          sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.tipoPagamento ===
                            'TOTAL') && (
                          <ButtonAction
                            title={'Selecionar modo de pagamento'}
                            titleLabel='Total'
                            pay={'formaPagamento'}
                            text={
                              'R$ ' +
                              sttCtxChkt.agendamentoConfirme.valorTotal
                                .toFixed(2)
                                .toString()
                                .replace('.', ',')
                            }
                            confirmed={sttCtxChkt.selTotal}
                            onClick={() => actionsChkt.selectTotalPay()}
                          />
                        )}
                        {Object.keys(reagendamento).length === 0 &&
                        sttCtxChkt.horaFixaSelecionada === null &&
                        !sttCtxChkt.selTotal &&
                        (sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.tipoPagamento ===
                          'AMBOS' ||
                          sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.tipoPagamento ===
                            'SINAL') ? (
                          <ButtonAction
                            pay={'formaPagamento'}
                            title={'Selecionar modo de pagamento'}
                            titleLabel={`${sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento.porcentagemSinal}% do valor do horário`}
                            text={`R$${Services.ReturnValorPorcentagem(
                              sttCtxChkt.agendamentoConfirme.quadra.regraAgendamento
                                .porcentagemSinal,
                              sttCtxChkt.agendamentoConfirme.valorTotal,
                            )
                              .toString()
                              .replace('.', ',')}`}
                            confirmed={sttCtxChkt.selSinal}
                            onClick={() => actionsChkt.selectSinalPay()}
                          />
                        ) : null}
                      </>
                    )}
                  </Grid>
                )
              )}
              <Grid item width={'100%'} sx={{ padding: '0px 30px 0px 15px' }}>
                {Object.keys(reagendamento).length > 0 &&
                !pagamentoLocal &&
                reagendamento.valorTotal === sttCtxChkt.agendamentoConfirme.valorTotal ? (
                  <></>
                ) : sttCtxChkt.selTotal || sttCtxChkt.selSinal ? (
                  <>
                    <Typography variant='h6' className='text-subtitle-low'>
                      Qual a forma de pagamento?
                    </Typography>
                    {sttCtxChkt.horaFixaSelecionada === null ? (
                      <>
                        {recebimentoPix && (
                          <ButtonAction
                            Icon={iconsPayment.logoPix}
                            titleLabel='PIX'
                            text='Pague pelo site'
                            pay={'payMetod'}
                            disabled={
                              pagamentosDisponiveis.pix === 'limiteDias' ||
                              !pagamentosDisponiveis.pix
                            }
                            unavailableMessage={
                              pagamentosDisponiveis.pix === 'limiteDias'
                                ? 'Pix indisponivel para agendamentos com mais de 4 meses de antecedência'
                                : !pagamentosDisponiveis.pix
                                  ? 'Pix indisponivel no momento'
                                  : ''
                            }
                            confirmed={sttCtxChkt.selPix}
                            sx={
                              Object.keys(reagendamento).length > 0 &&
                              pagamentoLocal && { opacity: 0.5 }
                            }
                            onClick={() => {
                              Object.keys(reagendamento).length > 0
                                ? avoidPaymentChange(
                                    pagamentoLocal &&
                                      'Ainda não é possível alterar um reagendamento para pagamento online',
                                  )
                                : actionsChkt.selectModePay('pix')
                            }}
                          />
                        )}
                        {recebimentoCartao && (
                          <ButtonAction
                            Icon={iconsPayment.creditCard}
                            titleLabel='Cartão de Crédito'
                            text='Pague pelo site'
                            pay={'payMetod'}
                            disabled={
                              pagamentosDisponiveis.cartao === 'limiteDias' ||
                              !pagamentosDisponiveis.cartao
                            }
                            unavailableMessage={
                              pagamentosDisponiveis.cartao === 'limiteDias'
                                ? 'Cartão de crédito indisponivel para agendamentos com mais de 28 dias de antecedência'
                                : !pagamentosDisponiveis.cartao
                                  ? 'Cartão de crédito indisponivel no momento'
                                  : ''
                            }
                            confirmed={sttCtxChkt.selCardCredit}
                            sx={
                              Object.keys(reagendamento).length > 0 &&
                              pagamentoLocal && { opacity: 0.5 }
                            }
                            onClick={() => {
                              Object.keys(reagendamento).length > 0
                                ? avoidPaymentChange(
                                    pagamentoLocal &&
                                      'Ainda não é possível alterar um reagendamento para pagamento online',
                                  )
                                : actionsChkt.handleModaisChkt('cartaoCredito', true)
                            }}
                          />
                        )}
                      </>
                    ) : null}

                    {recebimentoDinheiro && !sttCtxChkt.selSinal && (
                      <ButtonAction
                        Icon={iconsPayment.payColor}
                        titleLabel='Dinheiro'
                        pay={'payMetod'}
                        text='Pague no local'
                        confirmed={sttCtxChkt.selDinheiro}
                        onClick={() => {
                          Object.keys(reagendamento).length > 0 && !pagamentoLocal
                            ? avoidPaymentChange()
                            : actionsChkt.selectModePay('dinheiro')
                        }}
                      />
                    )}
                    {recebimentoMaq && !sttCtxChkt.selSinal && (
                      <ButtonAction
                        Icon={iconsPayment.payTerminal}
                        titleLabel='Máquina de Cartão'
                        text='Pague no local'
                        pay={'payMetod'}
                        confirmed={sttCtxChkt.selMaqCredit}
                        onClick={() => {
                          Object.keys(reagendamento).length > 0 && !pagamentoLocal
                            ? avoidPaymentChange()
                            : actionsChkt.selectModePay('maq')
                        }}
                      />
                    )}
                  </>
                ) : sttCtxChkt.diaria ? (
                  // Diária
                  <>
                    <Typography variant='h6' className='text-subtitle-low'>
                      Qual a forma de pagamento?
                    </Typography>
                    {sttCtxChkt.diaria.metodosPagamento.includes('Pagamento Local') ||
                      (sttCtxChkt.diaria.metodosPagamento.includes('Dinheiro') && (
                        <ButtonAction
                          Icon={iconsPayment.payColor}
                          titleLabel='Dinheiro'
                          pay={'payMetod'}
                          text='Pague no local'
                          confirmed={sttCtxChkt.selDinheiro}
                          onClick={() => {
                            actionsChkt.selectModePay('dinheiro')
                          }}
                        />
                      ))}
                    {sttCtxChkt.diaria.metodosPagamento.includes('PIX') && (
                      <ButtonAction
                        Icon={iconsPayment.logoPix}
                        titleLabel='PIX'
                        text='Pague pelo site'
                        pay={'payMetod'}
                        disabled={
                          pagamentosDisponiveis.pix === 'limiteDias' || !pagamentosDisponiveis.pix
                        }
                        unavailableMessage={
                          pagamentosDisponiveis.pix === 'limiteDias'
                            ? 'Pix indisponivel para agendamentos com mais de 4 meses de antecedência'
                            : !pagamentosDisponiveis.pix
                              ? 'Pix indisponivel no momento'
                              : ''
                        }
                        confirmed={sttCtxChkt.selPix}
                        onClick={() => {
                          actionsChkt.selectModePay('pix')
                        }}
                      />
                    )}
                    {sttCtxChkt.diaria.metodosPagamento.includes('Cartão de Crédito') && (
                      <ButtonAction
                        Icon={iconsPayment.creditCard}
                        titleLabel='Cartão de Crédito'
                        text='Pague pelo site'
                        pay={'payMetod'}
                        disabled={
                          pagamentosDisponiveis.cartao === 'limiteDias' ||
                          !pagamentosDisponiveis.cartao
                        }
                        unavailableMessage={
                          pagamentosDisponiveis.cartao === 'limiteDias'
                            ? 'Cartão de crédito indisponivel para agendamentos com mais de 28 dias de antecedência'
                            : !pagamentosDisponiveis.cartao
                              ? 'Cartão de crédito indisponivel no momento'
                              : ''
                        }
                        confirmed={sttCtxChkt.selCardCredit}
                        onClick={() => {
                          actionsChkt.handleModaisChkt('cartaoCredito', true)
                        }}
                      />
                    )}
                  </>
                ) : (
                  <></>
                )}
              </Grid>
            </GridContainer>

            <GridContainer
              final
              sx={{ width: '100%', padding: '0px', justifyContent: 'center', alignItems: 'center' }}
            >
              <Grid item width={'100%'}>
                <IconTitle
                  Icon={null}
                  title={`Resumo ${
                    !sttCtxChkt.diaria
                      ? Object.keys(reagendamento).length === 0
                        ? 'do Horário Avulso'
                        : 'do Reagendamento'
                      : 'da Diária'
                  }`}
                />
              </Grid>
              {Object.keys(reagendamento).length > 0 && (
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  aria-label='Resumo do Agendamento Tabs'
                  TabIndicatorProps={{
                    sx: {
                      height: 3,
                      borderRadius: '8px 8px 0 0',
                      transform: 'scaleX(0.5)',
                    },
                  }}
                >
                  <Tab
                    label={
                      <Typography sx={{ textTransform: 'none', fontFamily: 'inherit' }}>
                        Antes
                      </Typography>
                    }
                  />
                  <Tab
                    label={
                      <Typography sx={{ textTransform: 'none', fontFamily: 'inherit' }}>
                        Novo
                      </Typography>
                    }
                  />
                </Tabs>
              )}
              {selectedTab === 0 && (
                <ResumoAgendamento
                  data={reagendamento.dataInicio}
                  nomeEmpresa={reagendamento.empresa.nome}
                  nomeQuadra={reagendamento.quadra.descricao}
                  endereco={reagendamento.quadra.endereco}
                  horario={[
                    {
                      idgrade: reagendamento.idgrade,
                      dataInicio: reagendamento.dataInicio,
                      dataFinal: reagendamento.dataFinal,
                      valor: reagendamento.valor,
                      valorPromocional: reagendamento.valorPromocional,
                      promocao: reagendamento.promocao,
                      nobre: reagendamento.nobre,
                      status: reagendamento.status,
                      idHorario: reagendamento.idHorario,
                    },
                  ]}
                />
              )}
              {selectedTab === 1 && (
                <ResumoAgendamento
                  horario={sttCtxChkt.agendamentoConfirme?.agenda}
                  tituloDiaria={sttCtxChkt.diaria?.titulo}
                  data={sttCtxChkt.agendamentoConfirme?.agenda[0].dataInicio}
                  diaDiaria={sttCtxChkt.diaria?.dia}
                  nomeEmpresa={sttPg.empresa?.nome}
                  nomeQuadra={sttCtxChkt.agendamentoConfirme?.quadra.descricao}
                  endereco={sttCtxChkt.agendamentoConfirme?.quadra.endereco}
                />
              )}

              {Object.keys(reagendamento).length === 0 &&
                !sttCtxChkt.diaria &&
                (sttCtxChkt.horaFixaSelecionada === null ||
                  (sttCtxChkt.horaFixaSelecionada &&
                    sttCtxChkt.horaFixaSelecionada.tipoMensalista !== 'Indeterminado')) && (
                  <Grid item width={'calc(100% - 20px)'}>
                    <ButtonAction
                      fullWidth
                      title={'Adicionar um cupom de desconto'}
                      titleLabel={!sttCtxChkt.cupomAplicado ? 'Possui cupom de desconto?' : ''}
                      text={!sttCtxChkt.cupomAplicado ? '' : 'Cupom aplicado'}
                      onClick={() => {
                        actionsChkt.handleModaisChkt('cupom', true)
                      }}
                      confirmed={sttCtxChkt.cupomAplicado ? true : false}
                    />
                  </Grid>
                )}
              <div className='line-divisor' />
              {sttCtxChkt.diaria ? (
                <Grid container spacing={0} padding={'0px 0px 0px 15px'}>
                  <Grid item xs={4}>
                    <Typography
                      variant='h6'
                      className='text-label-low label-left'
                      sx={{ whiteSpace: 'nowrap' }}
                    >
                      Subtotal
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography
                      variant='h6'
                      className='text-label-low label-right'
                      sx={sttCtxChkt.cupomAplicado ? { textDecoration: 'line-through' } : {}}
                    >
                      {`R$ ${sttCtxChkt.diaria.valor.toFixed(2).replace('.', ',')}`}
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography
                      variant='h6'
                      className='text-label-low label-left'
                      sx={{ whiteSpace: 'nowrap', color: 'black', fontWeight: 'bold' }}
                    >
                      Você irá pagar agora
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography
                      variant='h6'
                      className='text-label-low label-right'
                      sx={{ color: 'black', fontFamily: 'jost-medium' }}
                    >
                      {`R$ ${sttCtxChkt.diaria.valor.toFixed(2).replace('.', ',')}`}
                    </Typography>
                  </Grid>
                </Grid>
              ) : (
                <Grid container spacing={0} padding={'0px 0px 0px 15px'}>
                  <Grid item xs={4}>
                    <Typography
                      variant='h6'
                      className='text-label-low label-left'
                      sx={{ whiteSpace: 'nowrap' }}
                    >
                      {sttCtxChkt.horaFixaSelecionada !== null &&
                      sttCtxChkt.horaFixaSelecionada.tipoMensalista === 'Indeterminado'
                        ? 'Valor por agendamento'
                        : 'Subtotal'}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    {sttCtxChkt.selTotal || sttCtxChkt.selSinal ? (
                      <>
                        {sttCtxChkt.horaFixaSelecionada !== null ? (
                          <Typography
                            variant='h6'
                            className='text-label-low label-right'
                            sx={sttCtxChkt.cupomAplicado ? { textDecoration: 'line-through' } : {}}
                          >
                            {sttCtxChkt.horaFixaSelecionada.tipoMensalista === 'Indeterminado'
                              ? `R$ ${sttCtxChkt.agendamentoConfirme.valorTotal.toFixed(2).replace('.', ',')}`
                              : `R$ ${sttCtxChkt.horaFixaSelecionada.valorTotal.toFixed(2).replace('.', ',')}`}
                          </Typography>
                        ) : (
                          <Typography
                            variant='h6'
                            className='text-label-low label-right'
                            sx={sttCtxChkt.cupomAplicado ? { textDecoration: 'line-through' } : {}}
                          >
                            R${' '}
                            {!sttCtxChkt.diaria
                              ? (
                                  sttCtxChkt.agendamentoConfirme.valorTotal +
                                  (sttCtxChkt.agendamentoConfirme.valorDesconto || 0)
                                )
                                  .toFixed(2)
                                  .replace('.', ',')
                              : sttCtxChkt.diaria.valor.toFixed(2).replace('.', ',')}
                          </Typography>
                        )}
                      </>
                    ) : (
                      <Typography variant='h6' className='text-label-low label-right'>
                        - - -
                      </Typography>
                    )}
                  </Grid>

                  {/* Cupom! */}
                  {sttCtxChkt.selTotal || sttCtxChkt.selSinal ? (
                    sttCtxChkt.agendamentoConfirme.valorDesconto > 0 ||
                    sttCtxChkt.cupomAplicado ||
                    reagendamento.valorDesconto ? (
                      <>
                        <Grid item xs={4}>
                          <Typography variant='h6' className='text-label-low label-left'>
                            Desconto
                          </Typography>
                        </Grid>
                        <Grid item xs={8}>
                          <Typography variant='h6' className='text-label-low label-right'>
                            {sttCtxChkt.horaFixaSelecionada !== null
                              ? Services.FormatValor(
                                  sttCtxChkt.horaFixaSelecionada?.descontoGeral || 0,
                                )
                              : reagendamento.valorDesconto
                                ? Services.FormatValor(reagendamento.valorDesconto)
                                : Services.FormatValor(
                                    sttCtxChkt.agendamentoConfirme.valorDesconto +
                                      (sttCtxChkt.cupomAplicado?.valorDesconto || 0),
                                  )}
                          </Typography>
                        </Grid>
                      </>
                    ) : (
                      <></>
                    )
                  ) : (
                    <></>
                  )}

                  {/* Sinal aqui! */}
                  {sttCtxChkt.selSinal && (
                    <>
                      <Grid
                        item
                        xs={4}
                        display='flex'
                        alignItems='center'
                        padding={'0px !important'}
                      >
                        <Typography
                          variant='h6'
                          className='text-label-low label-left'
                          sx={{ width: 'auto' }}
                        >
                          Valor Sinal
                        </Typography>
                        <Tooltip
                          arrow
                          placement='top'
                          title={
                            'Esse valor é o que deve ser pago agora, ele é o sinal do seu agendamento'
                          }
                        >
                          <span>
                            <AiOutlineQuestionCircle
                              size={15}
                              color='#808080'
                              style={{ cursor: 'pointer', marginLeft: '5px' }}
                            />
                          </span>
                        </Tooltip>
                      </Grid>
                      <Grid
                        item
                        xs={8}
                        className='contain-row tw-justify-end'
                        padding={'0px !important'}
                      >
                        <Box display='flex' alignItems='center' marginRight={'10%'}>
                          <Typography
                            variant='body2'
                            className='text-label-low label-right text-w-auto text-fs-h5'
                            sx={{ marginRight: '8px', whiteSpace: 'nowrap' }}
                          >
                            {`(${
                              Object.keys(reagendamento).length === 0
                                ? values.porcentagemSinal
                                : (
                                    sttCtxChkt.agendamentoConfirme.valorTotal /
                                    reagendamento.valorRealizado
                                  ).toFixed(2)
                            }% do subtotal)`}
                          </Typography>
                          <Typography
                            variant='h6'
                            className='text-label-low label-right text-w-auto'
                            sx={{ whiteSpace: 'nowrap' }}
                          >
                            {`R$ ${values.valorSinal.toFixed(2).toString().replace('.', ',')}`}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid
                        item
                        xs={4}
                        display='flex'
                        alignItems='center'
                        padding={'0px !important'}
                      >
                        <Typography
                          variant='h6'
                          className='text-label-low label-left'
                          sx={{ width: 'auto' }}
                        >
                          Valor restante
                        </Typography>
                        <Tooltip
                          arrow
                          placement='top'
                          title={
                            'Esse valor é o que falta para completar o valor total, ele deve ser pago no local'
                          }
                        >
                          <span>
                            <AiOutlineQuestionCircle
                              size={15}
                              color='#808080'
                              style={{ cursor: 'pointer', marginLeft: '5px' }}
                            />
                          </span>
                        </Tooltip>
                      </Grid>
                      <Grid item xs={8} padding={'0px !important'}>
                        <Box
                          display='flex'
                          alignItems='center'
                          justifyContent='flex-end'
                          marginRight={'10%'}
                        >
                          <Typography
                            variant='h6'
                            className='text-label-low label-right'
                            sx={{ whiteSpace: 'nowrap' }}
                          >
                            {`R$ ${(
                              values.valorSubtotal -
                              values.valorSinal -
                              (Object.keys(reagendamento).length > 0
                                ? Number(reagendamento.valorDesconto)
                                : 0)
                            )
                              .toFixed(2)
                              .toString()
                              .replace('.', ',')}`}
                          </Typography>
                        </Box>
                      </Grid>
                    </>
                  )}
                  {/* Se reagendamento e pagamento online, mostrar valor pago anteriormente aqui */}
                  {Object.keys(reagendamento).length > 0 && !pagamentoLocal && (
                    <>
                      <Grid item xs={4}>
                        <Typography variant='h6' className='text-label-low label-left'>
                          Valor pago anteriormente
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <Typography variant='h6' className='text-label-low label-right'>
                          {`R$ ${reagendamento.valorRealizado.toFixed(2).toString().replace('.', ',')}`}
                        </Typography>
                      </Grid>
                    </>
                  )}
                  {(Object.keys(reagendamento).length === 0 ||
                    (Object.keys(reagendamento).length > 0 && pagamentoLocal)) && (
                    <>
                      <Grid item xs={4}>
                        <Typography
                          variant='h6'
                          color={'black'}
                          className='text-label-low label-left'
                          sx={{
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {sttCtxChkt.horaFixaSelecionada !== null &&
                          sttCtxChkt.horaFixaSelecionada.tipoMensalista === 'Indeterminado'
                            ? 'Você irá pagar por agendamento'
                            : 'Você irá pagar'}
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        {sttCtxChkt.selTotal || sttCtxChkt.selSinal ? (
                          <>
                            {sttCtxChkt.horaFixaSelecionada !== null ? (
                              <Typography
                                variant='h6'
                                color={'black'}
                                className='text-label-low label-right'
                              >
                                {sttCtxChkt.horaFixaSelecionada.tipoMensalista === 'Indeterminado'
                                  ? `R$ ${sttCtxChkt.horaFixaSelecionada.prePedidos[0].valor.toFixed(2).toString().replace('.', ',')}`
                                  : sttCtxChkt.cupomAplicado
                                    ? `R$ ${(
                                        sttCtxChkt.horaFixaSelecionada.valorTotal -
                                        sttCtxChkt.cupomAplicado.valorDesconto
                                      )
                                        .toFixed(2)
                                        .toString()
                                        .replace('.', ',')}`
                                    : `R$ ${sttCtxChkt.horaFixaSelecionada.valorTotal.toFixed(2).toString().replace('.', ',')}`}
                              </Typography>
                            ) : (
                              <Typography
                                variant='h6'
                                color={'black'}
                                className='text-label-low label-right'
                              >
                                {sttCtxChkt.diaria
                                  ? `R$ ${sttCtxChkt.diaria.valorTotal.toFixed(2).toString().replace('.', ',')}`
                                  : sttCtxChkt.selTotal
                                    ? Object.keys(reagendamento).length > 0 && !pagamentoLocal
                                      ? `R$ ${values.valorSubtotal - reagendamento.valorTotal.toFixed(2).toString().replace('.', ',')}`
                                      : `R$ ${(values.valorSubtotal - (reagendamento ? reagendamento.valorDesconto || 0 : sttCtxChkt.cupomAplicado?.valorDesconto || 0)).toFixed(2).toString().replace('.', ',')}`
                                    : `R$ ${values.valorSinal.toFixed(2).toString().replace('.', ',')}`}
                              </Typography>
                            )}
                          </>
                        ) : (
                          <Typography
                            variant='h6'
                            color={'black'}
                            className='text-label-low label-right'
                          >
                            - - -
                          </Typography>
                        )}
                      </Grid>
                    </>
                  )}
                </Grid>
              )}
              <div className='line-divisor' />
              <Grid container spacing={1} padding={'0px 0px 0px 15px'}>
                <Grid item xs={12} padding={'0px !important'}>
                  <Typography
                    component={'div'}
                    variant='body2'
                    marginBottom={'5px'}
                    className='text-label-low text-center'
                  >
                    Ao confirmar o {Object.keys(reagendamento).length > 0 && 're'}agendamento, você
                    concorda com as{' '}
                    <button className='text-click-hig' onClick={() => Showregras()} tabIndex={0}>
                      regras de cancelamento
                    </button>{' '}
                  </Typography>
                </Grid>
                <Grid item xs={12} padding={'0px !important'}>
                  <InputButton
                    variant='contained'
                    color='primary'
                    disabled={VerificaBttConfirmar()}
                    width={'95%'}
                    style={{ margin: '0px 0px 15px 0px' }}
                    onClick={() => StartActionConfirme()}
                  >
                    {ReturnLabelBttConfirmar()}
                  </InputButton>
                </Grid>
              </Grid>
            </GridContainer>
          </Box>
        </Box>
      )}
    </>
  )
}

const GridContainer = ({ children, final = false, style = {} }) => (
  <Grid
    container
    rowSpacing={1}
    flexWrap={'nowrap'}
    direction='column'
    style={style}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
      height: 'auto',
      width: '33%',
      padding: '0px 10px 0px 10px',
      borderTop: final ? '10px solid var(--color-border-hig)' : 'none',
      boxShadow: final ? '0 0 10px rgba(0, 0, 0, 0.5)' : 'none',
    }}
  >
    {children}
  </Grid>
)

const stMob = {
  containHeader: {
    display: 'flex',
    position: 'relative',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    padding: '10px',
  },
  containListEsports: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'auto',
    padding: '0px',
    overflow: 'auto',
  },
  iconClosed: {
    position: 'absolute',
    top: '5px',
    right: '5px',
    color: 'var(--color-text-pri)',
    height: '30px',
    width: '30px',
    cursor: 'pointer',
  },
}
